module.exports = __webpack_public_path__ + "static/media/r1.35a63a09.png";